<template>
  <div class="pr-4 pl-3 py-3 space-y-3 cursor-pointer">
    <CtaTeacher v-if="$auth.user.role === 'teacher'" />
    <nuxt-link
      exact
      :to="localePath({ name: $routeName.dashboard_name })"
      class="flex items-center text-gray-medium hover:text-blue-primary transition-colors"
    >
      <AppIcon
        name="view-dashboard-outline"
        viewBox="0 0 12 12"
        size="tiny"
      />
      <span class="text__sub--1 mr-2">
        {{ $t("user_avatar.dashboard") }}
      </span>
    </nuxt-link>
    <nuxt-link
      exact
      :to="localePath({ name: $routeName.dashboard_wallet_name })"
      class="flex items-center text-gray-medium hover:text-blue-primary transition-colors"
    >
      <AppIcon
        name="account-wallet"
        size="small"
      />
      <span class="text__sub--1 mr-2 whitespace-nowrap">
        {{ $t("user_avatar.wallet") }}
      </span>
      <span
        v-if="$auth.user.wallet.user.total_credit"
        class="text-blue-primary text__sub--1 mr-3 whitespace-nowrap"
      >
        {{ $auth.user.wallet.user.total_credit | currency }}
        <span class="text__sub--4 whitespace-nowrap">
          {{ $t("currency") }}
        </span>
      </span>
      <span
        v-if="!$auth.user.wallet.user.total_credit"
        class="text-blue-primary text__sub--3 mr-3 whitespace-nowrap"
      >
        {{ $t("charge_wallet") }}
      </span>
    </nuxt-link>
    <nuxt-link
      exact
      :to="localePath({ name: $routeName.dashboard_my_requests_name })"
      class="flex items-center text-gray-medium hover:text-blue-primary transition-colors"
    >
      <AppIcon
        name="text-box-check-outline"
        size="small"
      />
      <span class="text__sub--1 mr-2">
        {{ $t("user_avatar.request") }}
      </span>
    </nuxt-link>
    <a
      :href="$routeName.logout"
      class="flex items-center text-gray-medium hover:text-blue-primary transition-colors"
    >
      <AppIcon
        name="exit"
        size="small"
      />
      <span class="text__sub--1 mr-2">
        {{ $t("user_avatar.exit") }}
      </span>
    </a>
  </div>
</template>

<script>
import CtaTeacher from '@library/element/dropdown/dropdown-list/cta-teacher-dashboard.vue'
import AppIcon from '@library/element/icon'
import convertDigit from '@filters/convert-digit'

export default {
  name: 'ListAvatar',
  components: { CtaTeacher, AppIcon },
  mixins: [convertDigit]
}
</script>
